<ph-dialog [open]="open" [attr.icon]="icon || null" [attr.heading]="heading" (ph-close)="closed.emit(false)">
    <span>{{ message }}</span>
    <ng-content></ng-content>

    <ph-actions slot="footer">
        <ph-button *ngIf="!hideCancel" variant="secondary" mode="filled" type="button" (click)="closed.emit(false)">{{ cancelLabel }}</ph-button>
        <ph-button [variant]="destructive ? 'error' : 'primary'" mode="filled" type="button" (click)="closed.emit(true)">{{ confirmLabel }}</ph-button>
    </ph-actions>
</ph-dialog>
